module.exports = __webpack_public_path__ + "img/shenli.f7abfac9.png";